<script>

import { ModalObject, hideModal } from "./Modal";


export function hide(){
    hideModal();
}


</script>

<div id="open-modal" class="modal-window">
    <div>
        <button on:click={hide} title="Close" class="modal-close">Close</button>
        <h1 class="modal-title">{$ModalObject.title}</h1>
        <div>{$ModalObject.body}</div>
        <button  class="btn btn-md btn-primary" id="modal-button-text" on:click={hide}>{$ModalObject.buttonText}</button>
    </div>
</div>




  <style>
.modal-window {
  position: fixed;
  background-color: rgba(51, 51, 51, 0.889);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;
  text-align: center;
}
.modal-window:target {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
}
.modal-title{
    margin-top: 0px;
    text-align: left;
}
.modal-window > div {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 2em;
  background: white;
}
.modal-window header {
  font-weight: bold;
}
.modal-window h1 {
  font-size: 150%;
  margin: 0 0 15px;
}

.modal-close {
  color: #aaa;
  line-height: 50px;
  font-size: 80%;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  width: 70px;
  text-decoration: none;
}
.modal-close:hover {
  color: black;
}

.btn{
    margin-top: 30px;
}


.modal-window > div {
  border-radius: 1rem;
}

.modal-window div:not(:last-of-type) {
  margin-bottom: 15px;
}

  </style>